// extracted by mini-css-extract-plugin
export default {"ellipsis":"FileName_ellipsis__-LNlC"};